import { SimpleChanges, OnChanges } from '@angular/core';
var ConnectSocialBarComponent = /** @class */ (function () {
    function ConnectSocialBarComponent() {
    }
    ConnectSocialBarComponent.prototype.ngOnChanges = function (changes) {
        if (changes.web) {
            this.webWithProtocol = this.web && this.web.startsWith('http') ? this.web : 'http://' + this.web;
        }
    };
    Object.defineProperty(ConnectSocialBarComponent.prototype, "strippedWebLink", {
        get: function () {
            // Strip the extra characters like https out
            if (!this._strippedWebLink) {
                this._strippedWebLink = this.web ? this.web.replace(/^\/\/|^.*?:(\/\/)?/, '') : '';
            }
            return this._strippedWebLink;
        },
        enumerable: true,
        configurable: true
    });
    return ConnectSocialBarComponent;
}());
export { ConnectSocialBarComponent };
